export const SITE_NAME = "E-Abatements";
export const APP_BASE_URL = "";
export const APP_PROTECTED_URL = "/app";
